import React from "react";
import "../styles/PrivacyPolicyStyle.css";

const JZCTerms = () => {
  return (
    <div className="jazz_discount_outer">
      <div className="container">
        <div className="discount_inner">
          <h2>Terms &amp; Conditions and Content Policy</h2>
          <p>
            <strong>Last Modified: 15/09/26</strong>
          </p>
          <br />

          {/* Section 1: Definitions and Acceptance of Terms */}
          <h3>1. Definitions and Acceptance of Terms</h3>

          <h3>1.1 Definitions</h3>
          <p>
            In these Terms and Conditions, unless the context requires
            otherwise, the following capitalized terms shall have the meanings
            set out below:
          </p>
          <ul>
            <li>
              <strong>"Company", "we", "us", or "our"</strong> means
              eConceptions, the entity that owns and operates the Platform.
            </li>
            <li>
              <strong>"Platform"</strong> means the Jobup website (
              <a href="https://jobup.mobi/">https://jobup.mobi/</a>), mobile
              application, and all associated digital properties through
              which the Services are delivered.
            </li>
            <li>
              <strong>"Services"</strong> means all content, features,
              functionality, and subscription-based services offered on or
              through the Platform, whether accessed as a guest or as a
              registered User.
            </li>
            <li>
              <strong>"User", "you", or "your"</strong> means any individual
              who accesses, browses, or uses the Platform or the Services,
              whether as a guest or a registered user.
            </li>
            <li>
              <strong>"Subscriber"</strong> means a User who has successfully
              subscribed to a paid subscription plan offered by the Company
              through an applicable Billing Provider.
            </li>
            <li>
              <strong>"Active Subscriber"</strong> means a Subscriber whose
              paid subscription is valid and active at the relevant time and
              has not expired, been cancelled, suspended, terminated, or
              otherwise become inactive, including due to failed payment or
              any other applicable reason.
            </li>
            <li>
              <strong>"Billing Provider"</strong> means the third-party
              mobile carrier, payment gateway, or other entity through which
              subscription fees are charged and collected on behalf of the
              Company, including JazzCash or other mobile wallets, where
              applicable.
            </li>
            <li>
              <strong>"Content"</strong> means all text, images, graphics,
              videos, audio, software, data compilations, page layout,
              underlying code, and any other materials available on or
              through the Platform.
            </li>
            <li>
              <strong>"User Content"</strong> means any content, including
              but not limited to comments, reviews, ratings, feedback, or
              other materials, posted, submitted, uploaded, or otherwise
              shared by a User on or through the Platform.
            </li>
            <li>
              <strong>"Reward"</strong> means any prize, voucher, gift,
              credit, promotional benefit, or other benefit offered by the
              Company in connection with a Promotion.
            </li>
            <li>
              <strong>"Promotion"</strong> means any contest, giveaway, lucky
              draw, reward program, promotional campaign, or similar
              activity conducted by or on behalf of the Company through or
              in connection with the Platform.
            </li>
            <li>
              <strong>"Privacy Policy"</strong> means the Company's privacy
              policy as published on the Platform and updated from time to
              time, which governs the collection, use, storage, and
              protection of personal information.
            </li>
            <li>
              <strong>"Terms" or "Terms and Conditions"</strong> means these
              terms and conditions, together with the Privacy Policy and any
              schedules, annexures, promotional terms, or documents
              expressly incorporated by reference.
            </li>
          </ul>
          <br />

          <h3>2 Acceptance of the Terms and Conditions</h3>
          <p>
            Welcome to JobUp, a platform built to connect people with
            meaningful career opportunities, professional connections, and
            knowledge that helps you grow. These Terms and Conditions set
            out the legal framework governing your use of the Platform and
            the Services.
          </p>
          <p>
            Please read these Terms carefully before accessing or using the
            Services. By accessing, browsing, registering for, subscribing
            to, or otherwise using the Platform or Services, you acknowledge
            that you have read, understood, and agree to be bound by these
            Terms and the Privacy Policy.
          </p>
          <p>
            If you do not agree with any provision of these Terms, you must
            not access or use the Platform or Services.
          </p>
          <p>
            Your continued use of the Platform following the publication of
            revised Terms constitutes your acceptance of, and agreement to,
            such revised Terms, subject to applicable law.
          </p>
          <br />

          {/* Section 3: General Terms and Conditions */}
          <h3>3. General Terms and Conditions</h3>
          <p>
            These Terms govern the use of the Platform and Services. The
            Services may include free and subscription-based content,
            features and functionality. Where a particular Promotion,
            subscription offer or other service is subject to additional
            terms, those terms will apply together with these Terms to the
            extent expressly stated.
          </p>
          <br />

          {/* Section 4: Eligibility and Age Requirements */}
          <h3>4. Eligibility and Age Requirements</h3>
          <p>
            The Services are intended for Users who are at least eighteen
            (18) years of age. By using the Platform, you represent and
            warrant that you are at least 18 years old and have the legal
            capacity to enter into a binding agreement.
          </p>
          <p>
            Where permitted by applicable law, the Company may allow Users
            under 18 to access certain Services only under the direct
            supervision and with the express consent of a parent or legal
            guardian who agrees to be bound by these Terms.
          </p>
          <p>
            The Company may request reasonable proof of age or other
            information to verify eligibility and may suspend or terminate
            access where a User is found to be ineligible. The Company is
            not responsible for a User's misrepresentation of age or
            eligibility.
          </p>
          <p>
            Eligibility requirements for Promotions and Rewards may be more
            restrictive than the general eligibility requirements for
            accessing the Platform. In particular,{" "}
            <strong>
              access to the Platform does not, by itself, make a User
              eligible to participate in or receive a Reward.
            </strong>
          </p>
          <br />

          {/* Section 5: Accessing the Platform and Account Security */}
          <h3>5. Accessing the Platform and Account Security</h3>
          <p>
            The Company may withdraw, amend, suspend or restrict access to
            the Platform or any part of the Services from time to time. The
            Company does not guarantee that the Platform will be available
            at all times or free from interruption, delay or technical
            problems.
          </p>
          <p>Where an account is required, you are responsible for:</p>
          <ul>
            <li>
              Providing accurate, current and complete information and
              keeping that information up to date;
            </li>
            <li>
              Maintaining the confidentiality of your username, password and
              other account credentials;
            </li>
            <li>All activity occurring under your account; and</li>
            <li>
              Promptly notifying the Company of any unauthorized access or
              other security breach.
            </li>
          </ul>
          <p>
            Your account is personal to you. You must not share, transfer,
            sell or otherwise provide access to your account to another
            person. The Company may suspend or terminate an account that is
            shared or used in violation of these Terms.
          </p>
          <p>
            The Company may disable any username, password or other
            identifier where it reasonably believes that you have violated
            these Terms or that such action is necessary to protect the
            Platform, other Users or the Company's legitimate interests.
          </p>
          <br />

          {/* Section 6: Subscriptions and Charges */}
          <h3>6. Subscriptions and Charges</h3>

          <h3>6.1 Subscription Plans</h3>
          <p>
            The Services may be offered to eligible customers through
            subscription plans. Subscriptions may be purchased through the
            Platform or through advertising links or other channels
            promoted by the Company.
          </p>
          <br />
          <div className="terms-table-container">
            <table
              className="terms-table"
              border={1}
              cellPadding="8"
              cellSpacing="0"
            >
              <thead>
                <tr>
                  <th colSpan={3}>Weekly (7 days)</th>
                  <th colSpan={3}>Monthly (30 days)</th>
                </tr>
                <tr>
                  <th>Plan</th>
                  <th>Excl. Tax</th>
                  <th>Incl. Tax</th>
                  <th>Plan</th>
                  <th>Excl. Tax</th>
                  <th>Incl. Tax</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Basic</td>
                  <td>Rs 50</td>
                  <td>Rs 60</td>
                  <td>Elite Value</td>
                  <td>Rs 360</td>
                  <td>Rs 430</td>
                </tr>
                <tr>
                  <td>Value</td>
                  <td>Rs 75</td>
                  <td>Rs 89</td>
                  <td>Elite Pro</td>
                  <td>Rs 460</td>
                  <td>Rs 549</td>
                </tr>
                <tr>
                  <td>Pro</td>
                  <td>Rs 100</td>
                  <td>Rs 119</td>
                  <td>Elite Premium</td>
                  <td>Rs 560</td>
                  <td>Rs 668</td>
                </tr>
                <tr>
                  <td>Ultra</td>
                  <td>Rs 125</td>
                  <td>Rs 149</td>
                  <td>Signature</td>
                  <td>Rs 660</td>
                  <td>Rs 788</td>
                </tr>
                <tr>
                  <td>Premium</td>
                  <td>Rs 150</td>
                  <td>Rs 179</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
              </tbody>
            </table>
          </div>
          <br />
          <p>
            The Company may introduce, modify, discontinue or replace
            subscription plans from time to time, subject to applicable law
            and the terms of the applicable Billing Provider.
          </p>
          <br />

          <h3>6.2 Auto-Renewal</h3>
          <p>
            Unless otherwise stated at the time of subscription, subscription
            plans automatically renew at the end of each billing cycle
            unless you cancel before the applicable renewal date. By
            subscribing, you authorize the Company and/or applicable Billing
            Provider to charge the applicable subscription fee at the
            beginning of each renewal period.
          </p>
          <p>
            You are responsible for managing and cancelling your
            subscription if you no longer wish to use the Services. The
            Company is not required to send renewal reminders except where
            required by applicable law or the applicable Billing Provider.
          </p>
          <br />

          <h3>6.3 Billing, Payment and Failed Payments</h3>
          <p>
            Subscription fees are charged through the applicable Billing
            Provider, including mobile carrier billing or mobile wallet
            services where applicable. The billing date is determined by the
            date of your initial subscription and recurs according to the
            applicable subscription plan.
          </p>
          <p>
            Subscription charges are non-refundable. Any refund, where
            applicable and expressly approved by the Company or required
            under applicable law, shall be limited strictly to the
            subscription amount actually paid by the User for the relevant
            subscription. The User acknowledges and agrees that, to the
            fullest extent permitted by applicable law, no other amount,
            compensation, damages, costs, charges, expenses, or other
            payment or entitlement of any nature whatsoever shall be payable
            by the Company in connection with such refund. If a charge at
            the applicable package price point is unsuccessful, the Company
            and/or Billing Provider may attempt to process the subscription
            at another applicable price point in accordance with the
            applicable billing arrangement or offer.
          </p>
          <p>
            If a payment fails, the Company and/or Billing Provider may
            attempt to recharge the applicable subscription fee up to three
            (3) times within seventy-two (72) hours. If all attempts fail,
            access to premium content and subscription-based features may be
            suspended until successful payment is processed. A User whose
            subscription becomes inactive due to failed payment is not an
            Active Subscriber during the period of inactivity. You remain
            responsible for any subscription charges that have already
            accrued and remain unpaid, to the extent applicable and subject
            to applicable law.
          </p>
          <br />

          <h3>6.4 Refunds</h3>
          <p>
            All subscription fees and charges are non-refundable. Where a
            refund is expressly approved by the Company or is otherwise
            required under applicable law, such refund shall be limited
            strictly to the subscription amount actually paid by the User in
            respect of the relevant subscription.
          </p>
          <p>
            The User acknowledges and agrees that, to the fullest extent
            permitted by applicable law, the refund of the applicable
            subscription amount shall constitute the User's sole and
            exclusive monetary entitlement in respect of such refund, and no
            other amount, compensation, damages, costs, charges, expenses,
            losses, or other payment or entitlement of any nature whatsoever
            shall be payable by the Company in connection with or arising
            from such refund.
          </p>
          <p>
            For the avoidance of doubt, any refund shall not include any
            amount attributable to unused subscription periods, third-party
            charges, taxes, fees or other amounts, except to the extent such
            amount is required to be refunded under applicable law.
          </p>
          <br />

          <h3>6.5 Free Trials and Promotional Offers</h3>
          <p>
            The Company may offer free trials, discounted subscription
            rates, promotional subscriptions or other special offers.
            Unless you cancel before the applicable trial or promotional
            period ends, your subscription may automatically convert to a
            paid subscription at the then-current standard rate for the
            selected plan.
          </p>
          <p>
            Any automatic conversion and billing terms applicable to a free
            trial or promotional offer will be disclosed at the time of the
            offer.
          </p>
          <br />

          <h3>6.6 Changes to Pricing</h3>
          <p>
            The Company may change subscription fees, introduce new pricing
            tiers, discontinue existing plans or offer discounted or free
            subscriptions to eligible customers. Pricing changes will be
            communicated in advance where commercially practicable and
            where required by applicable law. Your continued use of the
            Services after a pricing change takes effect constitutes your
            acceptance of the revised pricing, subject to applicable law.
          </p>
          <br />

          {/* Section 7: Communications and Notifications */}
          <h3>7. Communications and Notifications</h3>
          <p>
            During activation and use of the Services, Subscribers may
            receive text messages, push notifications and other electronic
            communications relating to account activation, service updates,
            new features, service-related alerts, promotional offers and
            administrative notices.
          </p>
          <p>
            Text messages may be sent through the applicable Billing
            Provider's network and may be subject to applicable carrier
            terms and charges. You may opt out of promotional
            communications by following the unsubscribe instructions
            provided in the relevant communication. You may not opt out of
            service-related, transactional, security or administrative
            communications reasonably necessary for the operation of your
            account or delivery of the Services.
          </p>
          <br />

          {/* Section 8: Content and Intellectual Property */}
          <h3>8. Content and Intellectual Property</h3>
          <p>
            All content available on the Platform, including text, images,
            graphics, videos, audio, software, data compilations, page
            layout, underlying code and other materials (collectively,
            "Content"), is the intellectual property of the Company or its
            licensors and is protected by applicable intellectual property
            laws.
          </p>
          <p>
            The Jobup name, logo and related names, logos, product and
            service names, designs and slogans are trademarks of the
            Company or its affiliates. You must not use the Company's
            trademarks or other intellectual property without prior written
            permission.
          </p>
          <p>
            Nothing in these Terms grants you any right, title or interest
            in the Content or the Company's intellectual property, except
            for a limited, non-exclusive, non-transferable and revocable
            licence to access and use the Services strictly in accordance
            with these Terms.
          </p>
          <br />

          {/* Section 9: Content Protection and Anti-Piracy */}
          <h3>9. Content Protection and Anti-Piracy</h3>
          <p>You must not, directly or indirectly:</p>
          <ul>
            <li>
              download, copy, reproduce, record, capture, screen-record,
              screenshot, store or archive Content, except where expressly
              permitted by the Company;
            </li>
            <li>
              redistribute, broadcast, retransmit, publish or make Content
              available to any third party, including through social media,
              file-sharing platforms or messaging services;
            </li>
            <li>
              circumvent, disable or interfere with digital rights
              management, encryption or other content-protection
              mechanisms;
            </li>
            <li>
              remove, alter or obscure copyright, trademark or other
              proprietary notices;
            </li>
            <li>
              use automated tools, bots, scrapers or similar software to
              access, extract, copy or index Content; or
            </li>
            <li>
              create derivative works based on Content without
              authorization.
            </li>
          </ul>
          <p>
            Unauthorized use of Content may constitute a material breach of
            these Terms and may result in suspension or termination of your
            account and/or legal action, subject to applicable law.
          </p>
          <br />

          {/* Section 10: User-Generated Content */}
          <h3>10. User-Generated Content</h3>
          <p>
            The Platform may allow Users to post, submit, upload or
            otherwise share comments, reviews, ratings, feedback or other
            materials ("User Content").
          </p>
          <p>By submitting User Content, you:</p>
          <ul>
            <li>
              represent and warrant that you own or have all necessary
              rights, licences and permissions to submit the User Content
              and that it does not violate third-party rights or applicable
              law;
            </li>
            <li>
              grant the Company a non-exclusive, worldwide, royalty-free,
              perpetual, irrevocable, sub-licensable and transferable
              licence to use, reproduce, modify, adapt, publish, translate,
              create derivative works from, distribute, perform and display
              the User Content in any media and through any channels,
              subject to applicable law; and
            </li>
            <li>
              acknowledge that the Company has no obligation to publish,
              display or retain User Content and may remove or modify it at
              its discretion.
            </li>
          </ul>
          <p>
            The Company is not responsible or liable for the content,
            accuracy, legality or reliability of User Content posted by you
            or another User, except to the extent liability cannot be
            excluded under applicable law.
          </p>
          <br />

          {/* Section 11: Prohibited Conduct */}
          <h3>11. Prohibited Conduct</h3>
          <p>You must not:</p>
          <ul>
            <li>
              infringe the intellectual property rights of the Company, its
              licensors or any third party;
            </li>
            <li>
              interfere with or disrupt the Platform, its servers, networks
              or connected systems;
            </li>
            <li>
              impersonate another individual or entity or falsely represent
              an affiliation with any person or entity;
            </li>
            <li>
              engage in fraudulent, deceptive, illegal, abusive or harmful
              activity;
            </li>
            <li>
              upload, transmit or distribute viruses, malware, worms,
              trojan horses or other harmful code;
            </li>
            <li>
              attempt to gain unauthorized access to another User's
              account, computer system or network;
            </li>
            <li>
              use the Services for unauthorized commercial purposes,
              including advertising, solicitation or spam;
            </li>
            <li>
              send, post or transmit content that is defamatory, obscene,
              threatening, abusive, hateful or otherwise objectionable; or
            </li>
            <li>
              engage in activity that could disable, overburden or impair
              the Services or interfere with another party's use of the
              Platform.
            </li>
          </ul>
          <br />

          {/* Section 12: Copyright Infringement and Takedown Procedure */}
          <h3>12. Copyright Infringement and Takedown Procedure</h3>
          <p>
            If you believe that Content on the Platform infringes your
            copyright or other intellectual property rights, you may submit
            a written notice to the Company containing:
          </p>
          <ul>
            <li>
              a description of the copyrighted work or other intellectual
              property claimed to have been infringed;
            </li>
            <li>
              a description of where the allegedly infringing material is
              located on the Platform;
            </li>
            <li>
              your full legal name, address, telephone number and email
              address;
            </li>
            <li>
              a statement that you have a good-faith belief that the use of
              the material is not authorized by the rights holder, its
              agent or applicable law;
            </li>
            <li>
              a statement that the information provided is accurate and
              that you are the copyright owner or authorized to act on the
              owner's behalf; and
            </li>
            <li>your physical or electronic signature.</li>
          </ul>
          <p>
            Notices should be sent to:{" "}
            <a href="mailto:support@econceptions.cc">
              support@eConceptions.cc
            </a>
          </p>
          <p>
            The Company will investigate valid notices and may take
            appropriate action, including removal of allegedly infringing
            Content and suspension or termination of accounts of repeat
            infringers, subject to applicable law.
          </p>
          <br />

          {/* Section 13: Third-Party Links and Content */}
          <h3>13. Third-Party Links and Content</h3>
          <p>
            The Platform may contain links to third-party websites,
            applications, products, services or resources. Such links are
            provided for convenience only. The Company does not control or
            endorse third-party resources and is not responsible for their
            content, privacy practices, availability or terms.
          </p>
          <p>
            If you access a third-party website or service, you do so at
            your own risk and subject to the terms and policies applicable
            to that third party. The inclusion of a third-party link does
            not imply endorsement, sponsorship, recommendation or
            affiliation by the Company.
          </p>
          <br />

          {/* Section 14: Reliance on Information Posted */}
          <h3>14. Reliance on Information Posted</h3>
          <p>
            Information presented through the Platform is provided for
            general informational purposes. The Company does not warrant
            that such information is accurate, complete, current or
            suitable for any particular purpose. Any reliance placed on
            such information is at your own risk, except to the extent
            liability cannot be excluded under applicable law.
          </p>
          <p>
            The Platform may include Content provided by third parties.
            Statements and opinions expressed in third-party Content are the
            responsibility of the relevant provider and do not necessarily
            represent the views of the Company.
          </p>
          <br />

          {/* Section 15: Changes to the Platform and Service Availability */}
          <h3>15. Changes to the Platform and Service Availability</h3>
          <p>
            The Company may withdraw, amend, modify, suspend or discontinue
            any aspect of the Platform or Services, including features,
            Content or materials, from time to time.
          </p>
          <p>
            The Company does not guarantee uninterrupted, continuous,
            secure or error-free access. The Services may be subject to
            limitations, delays, interruptions, maintenance, technical
            issues and other problems inherent in internet and electronic
            communications. To the fullest extent permitted by applicable
            law, the Company shall not be liable for losses arising solely
            from temporary interruption or unavailability of the Services.
            No compensation, credit or refund shall be payable to any User
            for any period of downtime, interruption or unavailability of
            the Services, except to the extent required by applicable law.
          </p>
          <br />

          {/* Section 16: Disclaimer of Warranties */}
          <h3>16. Disclaimer of Warranties</h3>
          <p>
            TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, YOUR USE OF
            THE SERVICES, CONTENT, AND ANY ITEMS OR REWARDS OBTAINED
            THROUGH THE SERVICES IS AT YOUR OWN RISK.
          </p>
          <p>
            THE SERVICES, CONTENT, AND ITEMS OR REWARDS ARE PROVIDED ON AN
            "AS IS" AND "AS AVAILABLE" BASIS, WITHOUT WARRANTIES OF ANY
            KIND, WHETHER EXPRESS, IMPLIED, OR STATUTORY, EXCEPT WHERE SUCH
            WARRANTIES CANNOT LAWFULLY BE EXCLUDED.
          </p>
          <p>
            THE COMPANY DOES NOT WARRANT THAT THE SERVICES OR CONTENT WILL
            BE COMPLETE, SECURE, RELIABLE, ACCURATE, ERROR-FREE,
            UNINTERRUPTED, OR AVAILABLE AT ALL TIMES, OR THAT DEFECTS WILL
            BE CORRECTED.
          </p>
          <p>
            TO THE FULLEST EXTENT PERMITTED BY LAW, THE COMPANY DISCLAIMS
            WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT, FITNESS FOR A
            PARTICULAR PURPOSE, AND ANY OTHER IMPLIED WARRANTIES.
          </p>
          <p>
            Nothing in these Terms excludes or limits any warranty, right,
            or remedy that cannot lawfully be excluded or limited under
            applicable law.
          </p>
          <br />

          {/* Section 17: Limitation of Liability */}
          <h3>17. Limitation of Liability</h3>
          <p>
            TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, THE COMPANY,
            ITS AFFILIATES, LICENSORS, SERVICE PROVIDERS, EMPLOYEES,
            AGENTS, OFFICERS, PARTNERS, AND DIRECTORS SHALL NOT BE LIABLE
            FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL,
            EXEMPLARY, OR PUNITIVE DAMAGES ARISING OUT OF OR IN CONNECTION
            WITH YOUR USE OF, OR INABILITY TO USE, THE SERVICES, PLATFORM,
            CONTENT, THIRD-PARTY SERVICES, OR REWARDS.
          </p>
          <p>
            This limitation includes, to the extent permitted by law, loss
            of revenue, profits, business, anticipated savings, use,
            goodwill, data, or other intangible losses.
          </p>
          <p>
            Nothing in these Terms shall exclude or limit liability that
            cannot lawfully be excluded or limited.
          </p>
          <br />

          {/* Section 18: Indemnification */}
          <h3>18. Indemnification</h3>
          <p>
            To the fullest extent permitted by applicable law, you agree to
            defend, indemnify, and hold harmless the Company, its
            affiliates, licensors, service providers, officers, directors,
            employees, contractors, agents, suppliers, successors, and
            assigns from and against claims, liabilities, damages,
            judgments, losses, costs, and reasonable expenses arising out
            of or relating to:
          </p>
          <ul>
            <li>Your violation of these Terms.</li>
            <li>Your use of the Services.</li>
            <li>User Content submitted by you.</li>
            <li>Your unauthorized use of Platform Content.</li>
            <li>
              Your infringement or misappropriation of any third-party
              intellectual property or other rights.
            </li>
            <li>
              Any claim that your User Content caused damage to a third
              party.
            </li>
            <li>
              Any third-party claim or demand arising out of your use of
              the Platform.
            </li>
            <li>
              Your fraudulent, unlawful, or abusive conduct in connection
              with the Platform or a Promotion.
            </li>
          </ul>
          <br />

          {/* Section 19: Termination and Suspension */}
          <h3>19. Termination and Suspension</h3>
          <p>
            The Company may suspend, restrict or terminate your account or
            access to all or part of the Services where it reasonably
            determines that such action is necessary or appropriate,
            including for violation of these Terms, suspected fraudulent,
            abusive, deceptive or illegal activity, non-payment or failed
            payment of subscription fees, requests by law enforcement or
            government authorities, extended inactivity, or conduct that
            may harm the Company, Platform, other Users or third parties.
          </p>
          <p>
            Upon termination, your right to use the Services will
            immediately cease. Provisions which by their nature should
            survive termination will survive, including ownership
            provisions, warranty disclaimers, indemnification, limitations
            of liability and dispute resolution provisions.
          </p>
          <p>
            You may cancel your subscription at any time using the
            applicable cancellation method provided by the Platform or
            Billing Provider. Unless otherwise required by applicable law
            or expressly stated otherwise, cancellation takes effect at the
            end of the current billing cycle and no refund will be
            provided for any unused portion of the subscription period.
          </p>
          <br />

          {/* Section 20: Privacy and Data Protection */}
          <h3>20. Privacy and Data Protection</h3>
          <p>
            Your use of the Services is also governed by the Company's
            Privacy Policy, which is incorporated into these Terms by
            reference. The Privacy Policy explains how the Company
            collects, uses, stores and protects personal information.
          </p>
          <p>
            The Company may disclose User information where required by
            law, regulation, court order or government authority, or where
            otherwise permitted by applicable law and the Privacy Policy.
          </p>
          <p>
            The Company implements commercially reasonable technical and
            organizational measures designed to protect User data against
            unauthorized access, alteration, disclosure or destruction.
            However, no method of internet transmission or electronic
            storage is completely secure, and the Company cannot guarantee
            absolute security.
          </p>
          <p>
            You are responsible for maintaining appropriate security of
            your account credentials and taking reasonable measures to
            protect your account and information. The Company is not
            responsible for any loss of, or inability to reconstruct, User
            data, and you are responsible for maintaining your own copies
            of any information important to you, to the extent applicable
            to your use of the Services.
          </p>
          <br />

          {/* Section 21: Changes to the Terms and Conditions */}
          <h3>21. Changes to the Terms and Conditions</h3>
          <p>
            The Company may modify, amend or update these Terms from time
            to time. Changes become effective when posted on the Platform
            unless a different effective date is stated.
          </p>
          <p>
            The Company will notify Users of material changes where
            commercially practicable and where required by applicable law.
            Your continued use of the Services following the effective date
            of revised Terms constitutes acceptance of the revised Terms,
            subject to applicable law.
          </p>
          <br />

          {/* Section 22: Force Majeure */}
          <h3>22. Force Majeure</h3>
          <p>
            The Company shall not be liable for any failure or delay in
            performing its obligations to the extent caused by
            circumstances beyond its reasonable control, including acts of
            God, war, terrorism, insurrection, civil disorder, national or
            local emergencies, acts or omissions of government authorities,
            industrial disputes, fire, lightning, explosion, flood,
            exceptionally severe weather, epidemic, pandemic, natural
            disasters, power failures, internet or telecommunications
            failures, technical failures, cyberattacks, system failures or
            interruptions required for maintenance.
          </p>
          <br />

          {/* Section 23: Governing Law and Dispute Resolution */}
          <h3>23. Governing Law and Dispute Resolution</h3>

          <h3>23.1 Governing Law</h3>
          <p>
            These Terms shall be governed by and construed in accordance
            with the laws of the Islamic Republic of Pakistan, without
            regard to conflict of law principles.
          </p>

          <h3>23.2 Amicable Resolution</h3>
          <p>
            If a dispute arises between you and the Company in connection
            with these Terms or the Services, the parties shall first
            endeavour to resolve the dispute amicably through good-faith
            negotiations within thirty (30) days after written notice of
            the dispute.
          </p>

          <h3>23.3 Arbitration</h3>
          <p>
            If the dispute cannot be resolved amicably within that period,
            either party may refer the dispute to binding arbitration in
            accordance with the Arbitration Act, 1940, as amended, or any
            successor legislation. The seat of arbitration shall be
            Islamabad, Pakistan. The language of arbitration shall be
            English. The arbitral award shall be final and binding on the
            parties, subject to applicable law.
          </p>

          <h3>23.4 Jurisdiction</h3>
          <p>
            Notwithstanding the arbitration provision above, either party
            may seek interim or injunctive relief from the competent courts
            in Islamabad where necessary to prevent irreparable harm
            pending arbitration. For enforcement of an arbitral award and
            matters that are not subject to arbitration under applicable
            law, the competent courts in Islamabad shall have exclusive
            jurisdiction, subject to applicable law.
          </p>
          <br />

          {/* Section 24: Waiver and Severability */}
          <h3>24. Waiver and Severability</h3>
          <p>
            The Company's failure to enforce any right or provision of
            these Terms shall not constitute a waiver of that right or
            provision. Any waiver shall be effective only to the extent
            expressly stated and shall not constitute a continuing waiver.
            Any waiver of a provision must be in writing and signed by an
            authorized representative of the Company to be effective.
          </p>
          <p>
            If any provision of these Terms is held to be invalid, illegal
            or unenforceable by a competent court or tribunal, that
            provision shall be limited or removed only to the minimum
            extent necessary, and the remaining provisions shall continue
            in full force and effect.
          </p>
          <br />

          {/* Section 25: Entire Agreement */}
          <h3>25. Entire Agreement</h3>
          <p>
            These Terms, together with the Privacy Policy and any
            additional agreements, schedules, promotional terms or policies
            expressly incorporated by reference, constitute the entire
            agreement between you and the Company concerning the Services
            and supersede prior agreements, communications, representations
            or understandings concerning the Services, except where
            expressly preserved.
          </p>
          <br />

          {/* Section 26: Contact Information */}
          <h3>26. Contact Information</h3>
          <p>
            For questions, concerns, complaints or enquiries regarding
            these Terms, please contact:
          </p>
          <p>
            <strong>Jobup (operated by eConceptions)</strong>
            <br />
            Website: <a href="https://jobup.mobi/">https://jobup.mobi/</a>
            <br />
            Email:{" "}
            <a href="mailto:support@econceptions.cc">
              support@eConceptions.cc
            </a>
          </p>
          <br />

          {/* Schedule A: Promotional Terms and Conditions */}
          <h3>SCHEDULE A</h3>
          <h3>Promotional Terms and Conditions</h3>
          <p>
            These Promotional Terms and Conditions form part of the Terms
            and Conditions and apply to Promotions conducted by or on
            behalf of the Company through or in connection with the
            Platform. Unless expressly stated otherwise in the terms of a
            specific Promotion, these general promotional rules apply.
          </p>
          <br />

          <h3>A.1 General Promotional Rules</h3>

          <h3>A.1.1 Eligibility</h3>
          <p>
            The Platform may be accessible to Users who are not
            Subscribers. However, access to or use of the Platform does not
            make a User eligible to enter, participate in, or receive any
            Reward under a Promotion. Unless the terms of a particular
            Promotion expressly provide otherwise, only Users who subscribe
            to the applicable service during the relevant Promotion
            Period/Month and remain Active Subscribers in accordance with
            the applicable Promotion terms are eligible to participate in
            the Promotion and receive any Rewards offered under it.
          </p>
          <p>
            The Company may impose additional eligibility requirements for
            a Promotion, including requirements relating to nationality,
            age, subscription plan, subscription duration, payment status,
            participation period, or other reasonable criteria.
          </p>
          <br />

          <h3>A.1.2 Active Subscriber Requirement</h3>
          <p>
            For purposes of Promotions, an <strong>Active Subscriber</strong>{" "}
            is a User whose applicable paid subscription is valid and
            active at the relevant time and whose subscription has not
            expired, been cancelled, suspended, terminated, or otherwise
            become inactive.
          </p>
          <p>
            For the avoidance of doubt, being an Active Subscriber alone
            does not make a User eligible for a Promotion. Where a
            Promotion is limited to Users subscribing during the Promotion
            Period, only Users whose subscription commenced during such
            Promotion Period shall be eligible for the Promotion and any
            Rewards.
          </p>
          <p>
            Where a Promotion requires a User to be an Active Subscriber,
            the Company may verify the User's subscription status at the
            time of entry, selection, winner verification, and/or Reward
            fulfilment, as applicable to the Promotion.
          </p>
          <p>
            Unless expressly stated otherwise, a User who becomes inactive
            before the applicable winner verification or Reward fulfilment
            process may cease to be eligible to receive the Reward.
          </p>
          <br />

          <h3>A.1.3 Verification and Disqualification</h3>
          <p>
            The Company may verify the eligibility and identity of any
            selected winner at any stage of the Promotion, including at the
            time of entry, winner selection, verification, or Reward
            fulfilment, and may request any information or documentation
            reasonably necessary to confirm eligibility, identity, or
            fulfilment requirements.
          </p>
          <p>
            The Company may disqualify a User or selected winner who cannot
            establish eligibility, provides false, misleading, inaccurate,
            or incomplete information, fails to satisfy any applicable
            Promotion requirements, attempts to manipulate or interfere
            with the Promotion or its operation, uses multiple accounts or
            any other method to obtain an unfair or improper advantage,
            attempts to circumvent subscription or eligibility
            requirements, or engages in fraudulent, abusive, deceptive,
            manipulative, or unlawful conduct, or otherwise violates these
            Terms or the terms of the applicable Promotion. The Company may
            also suspend or terminate the relevant User's account in
            addition to disqualifying the User from the Promotion, subject
            to applicable law.
          </p>
          <p>
            Where a selected winner is disqualified, cannot be contacted
            using the information provided, fails to respond within the
            applicable notification period, fails to complete the required
            verification or provide information reasonably necessary for
            Reward fulfilment, or otherwise fails to satisfy the applicable
            Reward fulfilment requirements, the Company may forfeit the
            Reward and, where reasonably practicable, select an alternative
            winner.
          </p>
          <br />

          <h3>A.1.4 Rewards</h3>
          <p>
            Rewards are subject to availability and the specific terms of
            the applicable Promotion.
          </p>
          <p>Unless expressly stated otherwise:</p>
          <ul>
            <li>
              Rewards are non-transferable and may not be sold, assigned,
              or transferred to another person.
            </li>
            <li>
              A winner may not request a cash alternative or exchange a
              Reward for cash.
            </li>
            <li>
              Rewards may be subject to the terms and conditions of the
              relevant third-party vendor.
            </li>
            <li>
              The Company does not guarantee that any particular Reward
              will remain available throughout the Promotion period.
            </li>
          </ul>
          <br />

          <h3>A.1.5 Reward Substitution</h3>
          <p>
            The Company may, where reasonably necessary, replace, modify,
            or substitute an advertised Reward, including where:
          </p>
          <ul>
            <li>The Reward becomes unavailable or is discontinued;</li>
            <li>
              There are stock shortages or supplier or vendor constraints;
            </li>
            <li>Delivery or fulfilment is not reasonably practicable;</li>
            <li>
              Technical, operational, regulatory, or legal circumstances
              affect fulfilment; or
            </li>
            <li>
              Circumstances beyond the Company's reasonable control prevent
              fulfilment of the advertised Reward.
            </li>
          </ul>
          <p>
            Where the Company substitutes a Reward, it may provide JazzCash
            credit of equivalent monetary value.
          </p>
          <p>
            The equivalent monetary value may be determined by reference to
            the value of the Reward stated in the applicable Promotion or,
            where appropriate, its prevailing reasonable value at the time
            of substitution.
          </p>
          <p>
            JazzCash credit provided as a substitute shall constitute full
            and final satisfaction of the Company's obligation to provide
            the applicable Reward. The Company is not required to obtain
            the winner's prior consent to a substitution made in
            accordance with this clause.
          </p>
          <br />

          <h3>A.1.6 Changes, Suspension or Termination of Promotions</h3>
          <p>
            The Company may amend, suspend, postpone, modify or terminate a
            Promotion where reasonably necessary, including due to
            technical issues, fraud, unauthorized intervention, operational
            limitations, legal or regulatory requirements or circumstances
            beyond the Company's reasonable control. Where reasonably
            practicable, the Company may provide notice of material
            changes.
          </p>
          <br />

          <h3>A.1.7 Company's Decision</h3>
          <p>
            Subject to applicable law, the Company's determination
            regarding eligibility, verification, disqualification, winner
            selection, Reward fulfilment and Reward substitution shall be
            final and binding.
          </p>
          <br />

          <h3>A.2 Subscribe and Win Contest</h3>

          <h3>A.2.1 Reward</h3>
          <p>
            One (1) Food Voucher or Jazzcash Credit or Free Mobile Data
            will be awarded to one (1) eligible winner through a monthly
            lucky draw.
          </p>
          <br />

          <h3>A.2.2 Winner Selection and Announcement</h3>
          <ul>
            <li>
              The winner will be selected randomly from the pool of Users
              who successfully subscribed to the applicable service during
              the Promotion Period/Month and satisfied all other
              applicable eligibility requirements.
            </li>
            <li>
              Only Users who satisfy all applicable eligibility
              requirements will be included in the eligible entry pool.
            </li>
            <li>
              The Company's determination regarding selection and
              verification of the winner shall be final and binding,
              subject to applicable law.
            </li>
            <li>
              The selected winner will be notified through telephone call
              and/or SMS within seventy-two (72) hours of the applicable
              draw date, where reasonably practicable.
            </li>
            <li>
              The winner's name may also be announced through the
              Company's official social media channels, including
              Instagram and Facebook, subject to applicable law and the
              Privacy Policy.
            </li>
          </ul>
          <br />

          <h3>A.2.3 Eligibility and Conditions</h3>
          <ul>
            <li>
              The User must have successfully subscribed to the applicable
              service during the Promotion Period to be eligible for the
              Promotion and any Reward.
            </li>
            <li>
              The User must have successfully completed the applicable
              subscription charge during the Promotion Period.
            </li>
            <li>
              Users who subscribed to the applicable service before the
              commencement of the Promotion Period shall not be eligible
              for the Promotion or any Reward, even if they remain Active
              Subscribers during the Promotion Period or on the date of
              the applicable draw.
            </li>
            <li>
              A User whose subscription has expired, been cancelled,
              suspended, terminated or otherwise become inactive may not
              be eligible to receive the Reward unless the applicable
              Promotion expressly provides otherwise.
            </li>
            <li>
              The User must be a citizen of Pakistan where Pakistani
              citizenship is expressly required for the Promotion.
            </li>
            <li>
              Where JazzCash is required for Reward fulfilment, the winner
              must have a valid JazzCash account associated with the
              winning mobile number or provide such other account details
              as may reasonably be required.
            </li>
            <li>
              Employees, affiliates and immediate family members of the
              Company may be excluded from participation where specified
              in the applicable Promotion.
            </li>
          </ul>
          <br />

          <h3>A.2.4 Marketing and Promotional Use</h3>
          <p>
            By participating in the Promotion, the winner may be requested
            to provide consent for the Company to use the winner's name,
            photograph and relevant promotional information for marketing,
            publicity and promotional purposes, subject to applicable law
            and the Privacy Policy. Where a photograph or other media is
            voluntarily provided by the winner for promotional purposes,
            the Company may use that material for the purposes communicated
            to the winner and subject to applicable law.
          </p>
          <br />

          <h3>A.2.5 Promotion Disruption</h3>
          <p>
            If the Promotion cannot operate as planned due to a computer
            virus, technical failure, tampering, unauthorized intervention,
            fraud, telecommunications failure, system failure or other
            circumstances beyond the Company's reasonable control, the
            Company may, to the extent reasonably necessary, disqualify
            affected entrants, modify, suspend or extend the Promotion,
            terminate or cancel it, or take other reasonable action
            necessary to protect its integrity.
          </p>
          <br />

          <h3>A.3 Promotional Reward Liability</h3>
          <p>
            To the fullest extent permitted by applicable law, the Company
            is not responsible for loss, damage, delay, defect, injury or
            other issues arising from a User's participation in a
            Promotion or use of a Reward, except where such liability
            cannot lawfully be excluded. Where a Reward is supplied by a
            third party, the User may also be subject to the third party's
            applicable terms and conditions. Nothing in these Promotional
            Terms excludes or limits liability that cannot lawfully be
            excluded or limited under applicable law.
          </p>
          <br />

          <h3>A.4 No Additional Entitlement</h3>
          <p>
            No User may claim any Reward, compensation, benefit or other
            entitlement beyond the Reward expressly announced for the
            applicable Promotion or any authorized substitute provided
            under these Terms. The Company has no obligation to provide an
            alternative Reward requested by a User. Where the Company
            substitutes a Reward with JazzCash credit under these Terms,
            the applicable credit constitutes full and final fulfilment of
            the Company's Reward obligation.
          </p>
          <br />
        </div>
      </div>
    </div>
  );
};

export default JZCTerms;